import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const LockerIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.91 2.91A.91.91 0 0 1 3.817 2h16.364a.91.91 0 0 1 .909.91v18.18a.91.91 0 0 1-.91.91H3.819a.91.91 0 0 1-.909-.91zm1.817.908v16.364h14.546V3.818z"
      clipRule="evenodd"
    />
    <path fill="currentColor" fillRule="evenodd" d="M11.09 20.182V3.818h1.82v16.364z" clipRule="evenodd" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.182 12H3.818v-.91h16.364zM12 16.546H3.818v-.91H12zM20.182 7.455H3.818v-.91h16.364z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
